import { createSelector } from 'reselect'
import differenceInDaysDateUtil from 'utils/date/difference-in-days'
import getFastTrackExpireOrExtensionDateLoyaltySelect
  from 'modules/loyalty/redux/selectors/get-fast-track-expire-or-extension-date'
import isFastTrackExpiredLoyaltySelect from 'modules/loyalty/redux/selectors/is-fast-track-expired'

const FAST_TRACK_EXPIRY_DIFF_IN_DAYS = 7

const isFastTrackExpiringSoonLoyaltySelect = createSelector(
  getFastTrackExpireOrExtensionDateLoyaltySelect,
  isFastTrackExpiredLoyaltySelect,
  /**
   * @param {Date|null} fastTrackExpirationDate
   * @param {Boolean} isFastTrackExpired
   */
  (fastTrackExpirationDate, isFastTrackExpired) => {
    if (!fastTrackExpirationDate || isFastTrackExpired) {
      return false
    }
    const differenceInDays = differenceInDaysDateUtil(new Date(fastTrackExpirationDate), new Date())
    return differenceInDays <= FAST_TRACK_EXPIRY_DIFF_IN_DAYS
  }
)

export default isFastTrackExpiringSoonLoyaltySelect
